<template>
  <b-row class="mb-2 align-items-center no-gutters">
    <b-col cols="1" class="d-flex justify-content-center align-items-center text-center">
      <div style="color: rgb(142 142 142); font-weight: 600;" :style="dia.seleccionado ? 'color: #0069aa; font-weight: 600;' : ''">
        {{ dia.nombreDia }}
      </div>
    </b-col>
    <b-col cols="4" class="px-2 d-flex justify-content-center align-items-center text-center"  :style="dia.seleccionado ? 'color: #0069aa; font-weight: 600;' : ''">
      {{dia.horaInicio | formatoHoraEstandar}}
    </b-col>
    <b-col cols="4 " class="px-2 d-flex justify-content-center align-items-center text-center" :style="dia.seleccionado ? 'color: #0069aa; font-weight: 600;' : ''">
      {{dia.horaFin | formatoHoraEstandar}}
    </b-col>
    <b-col cols="1" class="d-flex justify-content-center align-items-center text-center">
      <b-form-checkbox v-model="dia.seleccionado" :disabled="dia.horaInicio === 0 && dia.horaFin === 0">
      </b-form-checkbox>
    </b-col>
    <b-col cols="2" class="d-flex justify-content-center align-items-center text-center">
      <span style='font-size: small; color: #0069aa; font-weight: bold;'
            v-if="esNuevo">Nuevo Horario</span>
      <span style='font-size: small' class="bold text-danger" v-if="dia.horaInicio === 0 && dia.horaFin === 0">Sin operación</span>
    </b-col>
  </b-row>
</template>

<script>

export default {
  props: {
    /** @typedef {Object} DiaHorario
     * @property {number} idDia - ID del día (1=Lunes, 7=Domingo)
     * @property {string} inicial - Primera letra del día
     * @property {Object} apertura - Hora de apertura {HH, mm}
     * @property {Object} cierre - Hora de cierre {HH, mm}
     * @property {boolean} sinOperacion - Si el día no tiene operación */
    /** @type {DiaHorario} */
    dia: {
      type: Object,
      required: true
    },
    /** @type {boolean} Si los controles están deshabilitados */
    disabled: {
      type: Boolean,
      default: false
    },
    esNuevo: {
      type: Boolean,
      default: false
    }
  },
  created() {
    console.log("dia")
    console.log(this.dia)
  },
}
</script>

<style scoped>
.dia-circulo {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}
.dia-azul { background-color: #008FFF; color: #ffffff; font-weight: 600; }
.dia-gris { background-color: #dee2e6; color: #212529; font-weight: 600; }

::v-deep .tooltip-inner {
  font-size: 14px;
}
</style>
